import { LAttribute } from 'src/app/shared/models/domain/lattribute';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { ObjectWrapperUtil } from 'src/app/shared/utils/object.wrapper.util';
import { Util } from 'src/app/shared/utils/util';
import { CommonEnums } from 'src/app/shared/common.enums';
import { DatabaseWrappersFactory } from '../../databases/database.wrappers.factory';

export class LAttributesUtil {
    private static instance: LAttributesUtil;

    static getInstance() {
        if (!LAttributesUtil.instance) {
            LAttributesUtil.instance = new LAttributesUtil();
        }

        return LAttributesUtil.instance;
    }

    util: Util;
    objectWrapperUtil: ObjectWrapperUtil;

    /**
      * LAttributesUtil is a singleton class, so use LAttributesUtil.getInstance() method instead of creating new LAttributesUtil().
      */
    private constructor() {
        this.objectWrapperUtil = ObjectWrapperUtil.getInstance();
        this.util = Util.getInstance();
    }

    insert(lAttribute: LAttribute, lAttributes: Array<LAttribute>, objectWrapper: ObjectWrapper): void {
        lAttributes.push(lAttribute);

        this.objectWrapperUtil.addSub_Id(lAttribute.lAttr_Id, lAttribute, objectWrapper);
        this.objectWrapperUtil.addSubName(lAttribute.lAttrNm, objectWrapper);
    }

    getNewLAttribute(objectWrapper: ObjectWrapper, lAttrNm: string, lnk_Attr_Id: number, lnk_Obj_Inst_Id: number): LAttribute {
        var lAttribute: LAttribute = new LAttribute();

        lAttribute.lAttr_Id = this.objectWrapperUtil.getNewSub_Id(objectWrapper);
        lAttribute.lAttrNm = this.util.getNewName(lAttrNm, objectWrapper.subNames);

        lAttribute.lnk_Attr_Id = lnk_Attr_Id;
        lAttribute.lnk_Obj_Inst_Id = lnk_Obj_Inst_Id;

        lAttribute.obj_Id = objectWrapper.obj_Id;
        lAttribute.dxMp_Id = objectWrapper.dxMp_Id;

        return lAttribute;
    }

    getLAttributeName(lAttribute: LAttribute, objectWrapper: ObjectWrapper): string {
        if (lAttribute.lnk_Attr_Id == -1) return '';

        let attributeObject: any = objectWrapper.carryForwardAttributesHMapIds.get(lAttribute.lnk_Obj_Inst_Id + '-' + lAttribute.lnk_Attr_Id);
        if (attributeObject) return attributeObject.name;

        return ''; //lAttribute.lnk_Attr_Id.toString();
    }

    getLAttributeType(lAttribute: LAttribute, objectWrapper: ObjectWrapper): string {
        if (lAttribute.lnk_Attr_Id == -1) return '';

        var attributeObject: any = objectWrapper.carryForwardAttributesHMapIds.get(lAttribute.lnk_Obj_Inst_Id + '-' + lAttribute.lnk_Attr_Id);
        if (attributeObject) {
            return attributeObject.attrDTypNm;
        }

        // if (attributeObject) {
        //     var datatype = DIDatabases.getDatatype(objectWrapper.nativeDbTyp_Id, attributeObject.attrDTyp_Id);
        //     return datatype.name;
        // }

        return lAttribute.lnk_Attr_Id.toString();
    }

    getLAttributePrec(lAttribute: LAttribute, objectWrapper: ObjectWrapper): string {
        if (lAttribute.lnk_Attr_Id == -1) return '';

        var attributeObject: any = this.getLAttribute(lAttribute, objectWrapper);
        if (!attributeObject) return;

        if (DatabaseWrappersFactory.getInstance().showAttrPrec(objectWrapper.dbTyp_Id, attributeObject.attrDTyp_Id, attributeObject.attrPrec) != '')
            return attributeObject.attrPrec;
        else
            return '';
    }

    getLAttributeScale(lAttribute: LAttribute, objectWrapper: ObjectWrapper): string {
        if (lAttribute.lnk_Attr_Id == -1) return '';

        var attributeObject: any = this.getLAttribute(lAttribute, objectWrapper);
        if (!attributeObject) return;

        if (DatabaseWrappersFactory.getInstance().showAttrScale(objectWrapper.dbTyp_Id, attributeObject.attrDTyp_Id, attributeObject.attrPrec) != '')
            return attributeObject.attrScale;
        else
            return '';
    }

    getLAttribute(lAttribute: LAttribute, objectWrapper: ObjectWrapper): string {
        if (lAttribute.lnk_Attr_Id == -1) return '';

        let attributeObject: any = objectWrapper.carryForwardAttributesHMapIds.get(lAttribute.lnk_Obj_Inst_Id + '-' + lAttribute.lnk_Attr_Id);
        if (attributeObject) return attributeObject;

        return '';
    }

    copy(lAttributesTmp: Array<LAttribute>): Array<LAttribute> {
        let lAttributes: Array<LAttribute> = new Array<LAttribute>();

        for (let i: number = 0; i < lAttributesTmp.length; i++) {
            lAttributes.push(LAttribute.parse(lAttributesTmp[i]));
        }

        return lAttributes;
    }

    copyFrom(lAttributes: Array<LAttribute>, lAttributesTmp: Array<LAttribute>): void {
        let lAttributesMap: Map<number, LAttribute> = new Map<number, LAttribute>();

        for (let i: number = 0; i < lAttributes.length; i++) {
            let lAttribute: LAttribute = lAttributes[i] as LAttribute;
            lAttributesMap.set(lAttribute.lAttr_Id, lAttribute);
        }

        lAttributes.splice(0, lAttributes.length);

        for (let i: number = 0; i < lAttributesTmp.length; i++) {
            let lAttributeTmp: LAttribute = lAttributesTmp[i] as LAttribute;

            let lAttribute: LAttribute = lAttributesMap.get(lAttributeTmp.lAttr_Id);
            if (lAttribute) {
                lAttribute.copyFrom(lAttributeTmp);
            } else {
                lAttribute = LAttribute.parse(lAttributeTmp);
            }

            lAttributes.push(lAttribute);
        }
    }

    compare(lAttributes: Array<LAttribute>, lAttributesTmp: Array<LAttribute>): string {
        if (lAttributes.length != lAttributesTmp.length)
            return 'Attributes length mismatch.';

        for (let i: number = 0; i < lAttributes.length; i++) {
            let lAttribute: LAttribute = lAttributes[i] as LAttribute;
            let lAttributeTmp: LAttribute = lAttributesTmp[i] as LAttribute;

            if (lAttribute.compare(lAttributeTmp) != '')
                return 'lAttributes [' + i + '] is not equal.';
        }

        return '';
    }

    toString(lattributes: Array<LAttribute>): string {
        let str: string = '';

        str += 'LAttributes length: ' + lattributes.length + ' ';

        for (let i: number = 0; i < lattributes.length; i++) {
            str += lattributes[i].toString();
        }

        return str;
    }
}